<template>
    <div>
    <!-- <div style="display: none;" class="top-header-mobile p-2 d-flex align-items-center justify-content-between">
     <div class="logoTop-mob">
     <img src="../../../../static/fxView/images/logo1.png">
     </div>
   
    </div> -->
    <div class="top-sidebar-header d-flex align-items-center justify-content-between border-bottom py-0 mb-3">
        <div class="d-flex align-items-center">
            <h4>{{nameFunction(pageName)}}</h4>
        </div> 
        <!----------msz panel------------->
        <!--<p v-if="msz != ''" class="mszFade" :class="(msz_type == 'success')? 'alert alert-success' : 'error'">
            {{message}}
            <feather type="x"  v-if="message != ''" @click="message = ''"></feather>
        </p>-->
        <!-------------------------------->
        <div class="rightTop-head d-flex align-items-center cap_profile">
           
             <div class="notification alrtNotificationTP">
                <ul class="nav customNotify">
                    <li class="nav-item dropdown" :class="notificationShow?'active show':''" @click.prevent="(notificationShow)?notificationShow = false:notificationShow = true">
                        <a class="nav-link text-dark p-0 mr-3 mt-2 notificationShow" href="#">
                            <h4 class="position-relative"> <feather type="bell"></feather> 
                                <sup class="supFile" v-if="notificationUnreadList != '' && notificationUnreadList.length > 0">{{ notificationUnreadList.length}}</sup> 
                            </h4>
                        </a>
                        <div class="dropdown-menu" :class="(notificationShow)?'show':''">
                         <li class="head notificationShow">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span>Notifications ({{notificationUnreadList.length || 0}})</span>
                                    <span class="textLink" v-if="notificationUnreadList.length > 0" @click="markasRead()">Mark as read</span>
                                    <router-link to="/notification-list" class="textLink">View all</router-link>
                                </div>
                            </li> 
                            <ul class="customDroDown scrollbar">
                                <li class="notification-box" v-if="notificationUnreadList.length > 0" v-for="list in notificationUnreadList">
                                    <feather type="user" class="rounded-circle"></feather>
                                    <div class="dueName" v-html="list.msg">
                                        <!-- @click="singleReadNoti(list._id)" -->
                                    </div>
                                </li>
                                <li class="notification-box noneNotify" v-if=" notificationUnreadList.length == 0">
                                    <div class="imgNorIcon">
                                        <h5>No message notification</h5>
                                    </div>
                                </li>
                            </ul>
                         </div>
                    </li>
                </ul>
            </div>
            <div class="dropdown headerNot-mob border-left">
                <button class="btn dropdown-toggle pr-5" id="menu1" type="button" data-toggle="dropdown">
                <div class="user-header d-flex align-items-center">
                    {{ (get_user.username) ? get_user.username.charAt(0) : ''}}
                </div> 
                <span class="caret"></span></button>
                <ul class="dropdown-menu user p-0" role="menu" aria-labelledby="menu1">
                    <li role="presentation"><router-link :to="'/email-setting-list'" >Email Setting</router-link></li>
                    <!-- <li role="presentation"><router-link :to="'/notification-list'" >Notification</router-link></li> -->
                    <li role="presentation"><router-link :to="'/reset-password'" >Reset Password</router-link></li>
                    <li role="presentation" class="divider"></li>
                    <li role="presentation"><a role="menuitem" tabindex="-1" href="#" @click="logout()">Logout</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import * as firebase from "firebase/app";
    import 'firebase/messaging';
    export default {
        data() {
            return {
                message : '',
                notificationShow : false
            }
        },
        mixins: [fxViewMixins],  
        props:['pageName'],
        computed:{
            /*fdeOut(){
                console.log(this.msz)
                this.message = this.msz
                if(this.message != ''){
                    setTimeout(function(){$('.mszFade').fadeOut();}, 6000);
                }
            }*/
        },
        created(){
            this.intializeFirebase();
        },
        methods:{
            // readNotification(){
            //     this.notificationShow = true;
            //     this._runReadUnreadNotification({'globalParams' : {} ,'localParams' : {'parameter' : this}})
            // },
			nameFunction(getData){
				let nameString = "" ;
				let name_array = getData.split('-');
				for(let i=0 ; i<=name_array.length -1 ; i++){
					nameString = nameString +' '+name_array[i]
					
					if(i == name_array.length -1){
						return nameString;
					}
				}
			},
            ...mapActions({
                _runLogout: types.RUN_USER_LOGOUT,
                _runSaveuserToken: types.SAVE_FIREBASE_TOKEN
            }),
            logout(){
                const r = this.$router
                this._runLogout({
                    router: r,
                    parameter: this
                })
            },
            redirec(){
                alert("Notification Page should come here")
            },
            saveFirebaseNotification(token){
                // _runSaveuserToken
                const _that = this
                let input_json={
                    'globalParams' :{
                        "firebaseToken": token
                    },
                    'localParams' :{
                        "parameter" : _that
                    }
                }
                _that._runSaveuserToken(input_json)
            },
            intializeFirebase(){
                const _that = this
                const firebaseConfig = {
                  apiKey: "AIzaSyCmsD-2IT6CCFUyj_fSGnaqhANqVk8naic",
                  authDomain: "fxview-d860f.firebaseapp.com",
                  databaseURL: "https://fxview-d860f.firebaseio.com",
                  projectId: "fxview-d860f",
                  storageBucket: "fxview-d860f.appspot.com",
                  messagingSenderId: "462578346086",
                  appId: "1:462578346086:web:8e33088eca7ff2cbfbe5a7"
                };
                firebase.initializeApp(firebaseConfig)
                    navigator.serviceWorker.register('/static/firebase-messaging-sw.js').then(function(registration) {
                        // console.log('Service Worker Registered!', registration);
                        const messaging = firebase.messaging();
                        messaging.usePublicVapidKey("BCJRn_O4j3bPnNuhkqyPy7uDwXkMiT6wOl4rYZV8xX9wxGZeVrLLjNUrc3YnPIWi2gW0plEqzdicmWnSsMTBg3o");
                        messaging.useServiceWorker(registration);

                        messaging.getToken().then((currentToken) => {
                          if (currentToken) {
                            // console.log("Current Push notification token", currentToken)
                            //sendTokenToServer(currentToken);
                            //updateUIForPushEnabled(currentToken);
                            _that.saveFirebaseNotification(currentToken)
                          } else {
                            // Show permission request.
                            // console.log('No Instance ID token available. Request permission to generate one.');
                            // Show permission UI.
                            // updateUIForPushPermissionRequired();
                            // setTokenSentToServer(false);
                          }
                        }).catch((err) => {

                            // _that.reaskPermission()
                          // console.log('An error occurred while retrieving token. ', err);
                          // showToken('Error retrieving Instance ID token. ', err);
                          // setTokenSentToServer(false);
                        });

                        messaging.onMessage((payload) => {

                            console.log("payload=======================>", payload)
                            _that.$notify({
                                group: 'foo',
                                type : "warn",
                                title: 'User Facing issue in uploading document',
                                text: payload.data.title,
                                duration: 10000,
                                closeOnClick : _that.redirect()
                            });
                            // _that.newUpdate = true;
                            
                        });

                        messaging.onTokenRefresh(function () {
                          messaging.getToken().then(function (newToken) {
                            _that.saveFirebaseNotification(newToken)
                            // this.saveNotificationToken(newToken)
                          }).catch(function (err) {
                            console.log('Unable to retrieve refreshed token ', err)
                          })
                        })
                    }).catch(function(err) { 
                        console.error('Service Worker registration failed', err);
                });
            },
            markasRead(){
                const _that = this
                this._runReadUnreadNotification({ 'globalParams' :{ }, 'localParams' :{ "parameter" : _that } })
            },
            afterUnread(){
                this._runGetNotificationList({'globalParams' : {read: "0"} ,'localParams' : {'parameter' : this}})
            }
            // singleReadNoti(id){
            //     const _that = this
            //     this._runReadUnreadNotification({ 'globalParams' :{"notification_id": id}, 'localParams' :{ "parameter" : _that } })
            // },
        },
        mounted(){
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.notificationShow').length){
                    _that.notificationShow = false
                }
            })
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/website/shared/header.vue